export namespace heights {
  export const INPUT_HEIGHT = 48;
}
